/**
 * @module KeyframesFactory
 * @group Default Export
 */

export { KeyframesRuleNameTypeError, SourceTypeError } from './errors';

export { getDocumentStyleSheetsOnLoad } from './sourcing-stylesheets/getDocumentStyleSheetsOnLoad';
export { importStyleSheet } from './sourcing-stylesheets/importStyleSheet';

export { getStyleSheetKeyframes } from './parsing-stylesheet-keyframes/getStyleSheetKeyframes';
export { getAllStyleSheetKeyframesRules } from './parsing-stylesheet-keyframes/getAllStyleSheetKeyframesRules';
export { parseKeyframesRule } from './parsing-stylesheet-keyframes/parseKeyframesRule';

export { ParsedKeyframes, type ParsedKeyframesRules } from './data-types/ParsedKeyframes';
export { type CSSStyleSheetSource } from './data-types/CSSStyleSheetSource'
